export const openMenuSubItemsDuration = 150;

export const sizeToProgressSizeMap = {
    xsmall: 'uxsmall',
    small: 'xxsmall',
    medium: 'xsmall',
    large: 'small',
} as const;
